// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-card__content[data-v-e6e5f852]{display:grid;grid-gap:.75rem;gap:.75rem;max-height:200px;overflow-y:scroll}@media only screen and (min-width:600px){.new-card__content[data-v-e6e5f852]{max-height:300px}}.new-card__title[data-v-e6e5f852]{font-size:1.375rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
